import React from 'react';
import { useState } from 'react';
import Div from '../Div';
const accordionData = [
  {
    question: 'Can I choose my seats while booking online?',
    answer:
      'Yes! Our online booking system lets you view real-time seat availability and choose your preferred seats.',
  },
  {
    question: 'How many screens does MeghrazCinemaz have?',
    answer:
      'MeghrazCinemaz features 4 state-of-the-art screens with Dolby sound and HD digital projection.',
  },
  {
    question: 'What types of movies do you show?',
    answer:
      'We screen the latest Bollywood, Hollywood (English), Odia, Telugu, Tamil, and other regional films.',
  },
  {
    question: 'Do you offer parking facilities?',
    answer:
      'Yes, we have ample parking space for both two-wheelers and four-wheelers.',
  },
  {
    question: ' What does the Game Zone include?',
    answer:
      'Our Game Zone features a mix of arcade games, video game stations, racing simulators, and puzzle games suitable for all age groups.',
  },
];

export default function Accordion() {
  const [selected, setSelected] = useState(0);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h2 className="cs-accordian_title">{item.question}</h2>
            <span className="cs-accordian_toggle cs-accent_color">
              <svg
                width={15}
                height={8}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
          </Div>
          <Div className="cs-accordian_body">
            <Div className="cs-accordian_body_in">{item.answer}</Div>
          </Div>
        </Div>
      ))}
    </Div>
  );
}
